import { Grid, Button, Typography } from '@mui/material';
import React from 'react';
import { Link } from 'react-router-dom';
import FlightIcon from '@mui/icons-material/Flight';
import { getGlobalCookie } from '../../utils';
import SentimentSatisfiedAltIcon from '@mui/icons-material/SentimentSatisfiedAlt';

const PageNotFound = () => {

    return (
        <Grid container justifyContent="center" alignItems="center" style={{ minHeight: '80vh' }}>
            <Grid item style={{ textAlign: 'center' }}>
                <div className="page-not-found">
                    <Typography variant="h1" className="error-title">404</Typography>
                    <Typography variant="h2" className="error-message">
                        Page Not Found
                        <SentimentSatisfiedAltIcon sx={{color: '#AD1D03'}}/>
                    </Typography>
                    <Link exact to={getGlobalCookie('lessorAccess') && "/leases"}> Go to home! </Link>
                </div>
            </Grid>
        </Grid>
    );
}

export default PageNotFound;